import {
  MenuItemIconConfig,
  resolveNamedIcon,
} from '@/components/menu-item-icon';
import { MicroProduct } from '@domain/microproducts/loaders/use-microproducts-loader';
import { ReactNode } from 'react';

export const PROMOTED_MICROPRODUCT_ICON_SIZE = 24;

// Checks if the product has an icon that MenuItemIcon can render
export const hasRenderableIcon = (product: MicroProduct): boolean =>
  Boolean(product.displayIconUrl) ||
  resolveNamedIcon(product.displayIconName ?? undefined) !== undefined;

export const getMicroProductIconConfig = (
  product: MicroProduct,
  fallback?: ReactNode,
): MenuItemIconConfig => ({
  icon: fallback,
  iconName: product.displayIconName ?? undefined,
  iconUrl: product.displayIconUrl ?? undefined,
  id: product.id,
});
